import { FC, useState } from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {certificateLogin} from '../../../../store/auth'

import style from './style.m.less'

export type IProfiles = {
    uid: string
    name: string
}[]

type IProfilesModal = {
    allProfiles: IProfiles
    clearProfiles: () => void
    setProfile?: (profile: any) => void
    certificate?: any
}

const ProfilesModal: FC<IProfilesModal> = ({
    allProfiles, clearProfiles, setProfile, certificate
}) => {
    const { t } = useTranslation()
    const reduxDispatch = useDispatch()
    const [isModalVisible, setIsModalVisible] = useState(true)

    const goToProfile = () => {
        // полная перезагрузка, а не перерендер, так как нужно обновить все креденшны и данные пользователя
        window.location.href = '/profile'
    }

    const handleOk = async (uid: string) => {
        const {thumbprint} = certificate
        reduxDispatch(certificateLogin({ thumbprint, goToProfile, uid}))
    }

    const handleCancel = () => {
        setIsModalVisible(false)
        clearProfiles()
    }

    return (
        <Modal
            bodyStyle={{
                boxShadow: '0px 4px 18px rgba(10, 19, 52, 0.15)',
                borderRadius: '24px',
                padding: '32px',
                width: '680px',
            }}
            closable={false}
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            centered
        >
            <div className={style.profilesList}>
                <div className={style.modalHeader}>{t('login.chooseProfile')}</div>
            </div>
            {allProfiles?.map((item, index) => {
                return (
                    <div
                        className={index === 0 ? style.profileFirst : style.profile}
                        key={item.uid}
                        onClick={() => handleOk(item.uid)}
                    >
                        <div className={style.profileHeader}>{item.name}</div>
                    </div>
                )
            })}
        </Modal>
)
}

export default ProfilesModal